import { Text, View, Page } from "@react-pdf/renderer";

import { marlayTermsAndConditions } from "../helpers/helper";
import { styles } from "../styles";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function PlasticSurgeryText({
  facilityLogo,
  fullAddress,
  phoneNumber,
  facilityName,
  showAddress,
}: {
  facilityLogo: string;
  fullAddress: string;
  phoneNumber: string;
  facilityName: string;
  showAddress: boolean;
}) {
  return (
    <Page size="LETTER" style={styles.page}>
      <Header
        facilityLogo={facilityLogo}
        fullAddress={fullAddress}
        phoneNumber={phoneNumber}
        showAddress={showAddress}
      />
      <View style={styles.section}>
        <Text style={{ ...styles.bodyText, lineHeight: 1.2 }}>
          Please do not hesitate to contact{" "}
          <Text style={{ fontFamily: "Helvetica-Bold" }}>Dr. Markey </Text> or
          his staff with any questions. Thank you for visiting{" "}
          <Text style={{ fontFamily: "Helvetica-Bold" }}>
            Ascentist Plastic Surgery!
          </Text>
        </Text>
        <Text
          style={{
            ...styles.bodyText,
            lineHeight: 1.2,
            fontFamily: "Helvetica-Bold",
          }}
        >
          THIS AGREEMENT IS SUBJECT TO THE FOLLOWING TERMS AND CONDITIONS:
        </Text>
        <Text style={{ ...styles.bodyText, lineHeight: 1.2 }}>
          With my signature,
        </Text>
        {marlayTermsAndConditions.map((item, index) => (
          <Text
            style={{ ...styles.bodyText, lineHeight: 1.2 }}
            key={`marlay_${index}`}
          >
            {item}
          </Text>
        ))}
      </View>
      <View
        style={{
          marginTop: 20,
          width: "100%",
          marginLeft: 50,
          marginRight: 50,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Patient Name Printed: _____________________________
        </Text>
      </View>
      <View
        style={{
          marginTop: 30,
          width: "100%",
          marginLeft: 50,
          marginRight: 50,
          display: "flex",
          flexDirection: "row",
          gap: 20,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Patient Signature: _________________________________
        </Text>
        <Text
          style={{
            ...styles.bodyText,
            marginTop: 4,
          }}
        >
          Date: _____________
        </Text>
      </View>
      <Footer facilityName={facilityName} />
    </Page>
  );
}
